export var HEADER_SIZE_100 = 100;
export var HEADER_SIZE_200 = 200;
export var HEADER_SIZE_300 = 300;
export var HEADER_SIZE_400 = 400;
export var HEADER_SIZE_500 = 500;
export var HEADER_SHOW_DEFAULT = false;
